

































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

import {AxiosResponse} from "axios";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {eGameStage} from "@/common/enumData";


@Component({
    components: {
        Swiper,
        SwiperSlide,
    },
})
export default class GameHeader extends Vue {
    eGameStage = eGameStage;
    gamePath = this.$route.params.gamePath;
    game: any = {};

    loginUser = {};
    user: any = {}

    hashtags: string[] = [];
    userInfo: any = [];
    followingCnt: number = 0;
    followerCnt: number = 0;

    gameId = this.$route.query.game_id

    TMSswiperOption = {
        slidesPerView: 'auto',
        spaceBetween: '0.4%',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            300: {
                slidesPerView: 3.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 5.5
            },
            992: {
                slidesPerView: 7
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }


    async mounted() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch()
                this.loginUser = this.$store.getters.user;
            })
            .finally(() => {

            })


    }

    fetch() {
        this.$api.gameInfo(this.gamePath)
            .then((res: any) => {
                const {result} = res;
                const {game} = result;
                this.$store.commit('gameInfo', game)
                this.game = game;
                this.user = game.user
                this.hashtags = (game.hashtags.length > 0) ? game.hashtags.split(",") : undefined;

                // this.hashtags = ['a','b','b']
                // this.projectFetch();

            })
            .catch((err: any) => {


            })


    }

    projectFetch() {
        this.$api.getProject(this.game.id)
            .then((res: any) => {
                console.log('projectFetch', res)
            })
            .catch((err: any) => {

            })
    }

    moveHashtag(hashtag: string) {
        this.$router.push(`/${this.$i18n.locale}/search?q=${hashtag}`)
    }

    subscribe() {
        //todo : game 페이지구독 api 연결
        console.log(this.game.id);
    }

    playGame(pathname: string) {
        window.open(
            this.$store.getters.homeUrl + `play/${pathname}`, "_blank");

    }

    @Watch('$route.params.gamePath')
    watchParams() {
        this.gamePath = this.$route.params.gamePath
        this.fetch();
    }
}
